import { render, staticRenderFns } from "./RelatedDocumentPurchaseOrderDialog.vue?vue&type=template&id=2a9e686e&"
import script from "./RelatedDocumentPurchaseOrderDialog.vue?vue&type=script&lang=js&"
export * from "./RelatedDocumentPurchaseOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports